"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.showCCUnauthorizedError = exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactDom = _interopRequireDefault(require("react-dom"));
var _reactSharedUiNext = require("@eon-funke/react-shared-ui-next");
var _config = _interopRequireDefault(require("../../config/config"));
var COMPONENT_ID = 'call-center-unauthorized-error';
var CallCenterUnauthorizedError = function CallCenterUnauthorizedError() {
  var pageReload = function pageReload() {
    window.location.reload();
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    id: COMPONENT_ID
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "error-wrapper"
  }, /*#__PURE__*/_react.default.createElement("span", null, _config.default.AEM_CONFIG.callCenter.unauthorizedErrorMessage), /*#__PURE__*/_react.default.createElement(_reactSharedUiNext.Button, {
    type: "button",
    onClick: pageReload
  }, _config.default.AEM_CONFIG.callCenter.unauthorizedButtonLabel)));
};
var showCCUnauthorizedError = exports.showCCUnauthorizedError = function showCCUnauthorizedError() {
  var errorPortal = document.getElementById("".concat(COMPONENT_ID, "-container"));
  if (!errorPortal) {
    errorPortal = document.createElement('div');
    errorPortal.id = "".concat(COMPONENT_ID, "-container");
    document.body.appendChild(errorPortal);
  }
  _reactDom.default.render(/*#__PURE__*/_react.default.createElement(CallCenterUnauthorizedError, null), errorPortal);
  setTimeout(function () {
    errorPortal.classList.add('show-error-box');
  }, 0);
};
var _default = exports.default = CallCenterUnauthorizedError;